import { useEffect, useId, useRef, useState } from "react";
import type { ReactNode } from "react";
import { Button } from "./Button";

/** 펼침 메뉴 — 눌러 펼치고(1) 골라 닫는다(2) · Esc · 바깥 누르기로 닫힘 */
export function Menu({
  label,
  items,
  onPick,
  disabled,
  testId,
  ariaLabel,
}: {
  label: ReactNode;
  items: { id: string; label: ReactNode; on: boolean }[];
  onPick: (id: string) => void;
  disabled?: boolean;
  testId: string;
  ariaLabel: string;
}) {
  const [open, setOpen] = useState(false);
  const wrap = useRef<HTMLDivElement>(null);
  const listId = useId();
  useEffect(() => {
    if (!open) return;
    const off = (e: MouseEvent) => {
      if (!wrap.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", off);
    wrap.current?.querySelector<HTMLButtonElement>("[role=menuitemradio]")?.focus();
    return () => document.removeEventListener("mousedown", off);
  }, [open]);
  return (
    <div
      className="pf-menu"
      ref={wrap}
      onKeyDown={(e) => {
        if (e.key === "Escape") setOpen(false);
      }}
    >
      <Button
        variant="ghost"
        className="pf-btn--sm"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls={open ? listId : undefined}
        aria-label={ariaLabel}
        disabled={disabled}
        data-testid={testId}
        onClick={() => setOpen((o) => !o)}
      >
        {label}
      </Button>
      {open && (
        <div className="pf-menu__list" role="menu" id={listId} aria-label={ariaLabel}>
          {items.map((it) => (
            <button
              key={it.id}
              type="button"
              role="menuitemradio"
              aria-checked={it.on}
              className="pf-menu__item"
              data-value={it.id}
              onClick={() => {
                setOpen(false);
                if (!it.on) onPick(it.id);
              }}
            >
              {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
